import '../../dmView/style/App.css'; // Import your CSS file

import skullpng from '../pics/imageOverlays/skulls/skull.png'; 
import bloodied1 from '../pics/imageOverlays/blood/blood1.png'; 
import bloodied2 from '../pics/imageOverlays/blood/blood2.png'; 
import bloodied3 from '../pics/imageOverlays/blood/blood3.png'; 
import bloodied4 from '../pics/imageOverlays/blood/blood4.png'; 
import bloodied5 from '../pics/imageOverlays/blood/blood5.png'; 
import bloodied6 from '../pics/imageOverlays/blood/blood6.png'; 
import Exhaustion from './Exhaustion'; 
import DeathSaves from './DeathSaves';
import { effectImgMap, conditionImgMap } from '../../dmView/constants'

// Grab the digits out of creatureGuid
function stringToInt(str) {
    const numericStr = str.replace(/\D/g, '');  
    return numericStr ? parseInt(numericStr, 10) : 1;
}

function getBloodImg(creature) {
    const bloodiedArr = [bloodied1, bloodied2, bloodied3, bloodied4, bloodied5, bloodied6]
    const randomNumber = (stringToInt(creature.creatureGuid) % 6); // Generates numbers from 0 to 5
    return bloodiedArr[randomNumber]
}

const InspirationSvg = () => {
    return (
        <div className="inspoContainer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" className="inspoSvg">
                <g>
                    <path fill="#c53131" stroke="white" strokeWidth="1" d="M25,14.2c-6.4,0-11.7,5.1-12.2,11.5H2.2V30h10.9h23.8h10.9v-4.3H37.2C36.7,19.3,31.4,14.2,25,14.2z"></path>
                    <path fill="#C53131" stroke="white" strokeWidth="1" d="M26.9,10.3V0h-3.7v10.3c0.6-0.1,1.2-0.1,1.9-0.1S26.3,10.2,26.9,10.3z"></path>
                    <path fill="#C53131" stroke="white" strokeWidth="1" d="M42.4,5.3l-3-2.3l-6.4,9.1c1.1,0.5,2.2,1.2,3.1,2.1L42.4,5.3z"></path>
                    <path fill="#C53131" stroke="white" strokeWidth="1" d="M41.7,22.1l8.3-3.1l-1.3-3.6L40,18.7C40.7,19.7,41.3,20.9,41.7,22.1z"></path>
                    <path fill="#C53131" stroke="white" strokeWidth="1" d="M17.1,12.1L10.6,3l-3,2.3l6.3,8.9C14.9,13.3,16,12.6,17.1,12.1z"></path>
                    <path fill="#C53131" stroke="white" strokeWidth="1" d="M10,18.7l-8.7-3.3L0,18.9l8.3,3.1C8.7,20.9,9.3,19.7,10,18.7z"></path>
                </g>
            </svg>
        </div>
    )
}

const HealthBar = ({ current, max, iconSize, color }) => {
    const width = iconSize.width / 1.5;
    const height = iconSize.height / 30;
    const outlineWidth = iconSize.height / 100;

    const percent = Math.max(0, Math.min(1, current / max));
    const barWidth = width * percent;
    const gradientId = `hpGradient-${color}`;

    return (
        <div className='playerViewHpBar' style={{height: height + outlineWidth}}>    
            <svg width={width + outlineWidth} height={height + outlineWidth}>
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="30%" stopColor={color} />
                    </linearGradient>
                </defs>
                <rect
                    x={outlineWidth / 2}
                    y={outlineWidth / 2}
                    width={width}
                    height={height}
                    fill="#111"
                    rx={2}
                    stroke="#ddd"
                    strokeWidth={outlineWidth}
                />
                <rect
                    x={outlineWidth}
                    y={outlineWidth}
                    width={barWidth - outlineWidth}
                    height={height - outlineWidth}
                    fill={`url(#${gradientId})`}
                    rx={1}
                />
            </svg>
        </div>
    );
};

const tableView = window.location.pathname.includes('table')
// Send in specific player or monster blood effects
const Icon = ({creature, iconOptions, iconSize, isTurn}) => {

    // Player specific
    const isPlayer = creature.type === "player";
    let showDeathSaves = iconOptions.deathSaves && isPlayer && (creature.death_saves_success_count >= 0 && creature.death_saves_failure_count >= 0)

    const effectsFound = creature.effects.length > 0
    const showInitiativeBox = creature.initiative !== null && creature.initiative !== undefined && creature.initiative !== 0;
    const isExhausted = creature.exhaustionLvl > 0
    const hpPercent = creature.hit_points_current / creature.hit_points;

    let isDead = (creature.hit_points_current <= 0 || creature.exhaustionLvl === 6) && creature.type !== "global"
    let showHp = iconOptions.showHp
    let hpBar =  iconOptions.showHpBar
    
    let isBloodied = false;
    let tableViewHpColor = hpPercent > 0.55 ? 'green' : (hpPercent < 0.20 ? 'rgba(192, 47, 31, 1)' : 'rgba(214, 147, 1, 1)');

    if (hpPercent < 0.55 && iconOptions.showBlood) {
        isBloodied = true;
    }

    // By default, make ths name the same as the creature name
    // If it's a player, split the name into first and last names
    let name = creature.name;
    let lastName;
    if (isPlayer) {
        let restOfName;
        [name, ...restOfName] = creature.name.split(' ');
        lastName = restOfName.join(' ') || '';
    }

    if(!iconOptions.showDead && isDead) return null

    let sizes = {
        'tiny': .6,
        'small': .7,
        'medium': 1,
        'huge': 1.15,
        'large': 1.2,
        'gargantuan': 1.4
    };

    let teamWmod = 20 * iconOptions.teamSize || 0
    let teamHmod = 24 * iconOptions.teamSize || 0
    let sizeMod = iconOptions.showSize ? (sizes[creature.size?.toLowerCase()] || 1) : 1;
    iconSize = {width: (iconSize.width + teamWmod) * sizeMod, height: (iconSize.height + teamHmod) * sizeMod}

    console.log(creature.inspiration)

    return (
        <div className='iconImageDrop'>
            <div className="card"
                style={{
                    animation: isTurn ? 'playerViewIconShadowPulse 3s ease-in-out infinite' : '',
                    opacity: isDead && !isPlayer ? 0.75 : 1,
                    '--static-border': creature.border,
                    '--tableViewBlur': `${tableView ? '0px' : '5px'}`, 
                    boxShadow: `${tableView ? `0px 0px 0px ${iconSize.width/15}px` : '0px 0px 4px 5px'} ${creature.border}`, 
                    border: isTurn ? '4px solid #ffffffff' : '2px solid #d3d3d3ff',
                    width: `${iconSize.width + (isTurn ? iconSize.width/5 : 0)}px`,
                    height: `${iconSize.height + (isTurn ? iconSize.height/5 : 0)}px`,
                    '--iconWidth': `${iconSize.width + (isTurn ? iconSize.width/4 : 0)}px`, 
                    backgroundColor: tableView ? '#949e9bff': '#949e9bce',
                    marginTop: tableView ? '38px' : '0px'
                }}
            >
                {tableView && (
                    <>
                        <div className='overIconTableViewContainer'>
                            {effectsFound && (
                                <div className='effectsBarTableViewContainer'>
                                    <div className='effectsBarTableView'>    
                                        {creature.effects.map((effectName) => (
                                            <img className='effectPlayerViewTableView'
                                                key={effectName}
                                                src={effectImgMap[effectName] || conditionImgMap[effectName]}
                                                alt={effectName}
                                            />
                                        ))}
                                    </div>
                                </div>
                                
                            )}
                            {showHp && ( 
                                <div className="hpTableViewContainer" >
                                    <div className="hpTableView" 
                                        style={{
                                            borderBottom: `2px solid ${tableViewHpColor}`, 
                                            borderTop: `3px solid ${tableViewHpColor}`,
                                            textShadow: `-2px -2px 0 ${tableViewHpColor}, 2px -2px 0 ${tableViewHpColor}, -2px 2px 0 ${tableViewHpColor}, 2px 2px 0 ${tableViewHpColor}`

                                        }}>
                                        <span>{creature.hit_points_current}</span>
                                        {creature.hit_points_temp > 0 && <span className='tempHp hpTableViewSmall'>+{creature.hit_points_temp}</span>}
                                        <span className='hpTableViewSmall'> / {creature.hit_points}</span>
                                    </div>
                                </div>
                            )}
                            {hpBar && (
                                <div className='hpBarTableViewContainer'>
                                    <div className='hpBarTableView'>    
                                        <HealthBar current={creature.hit_points_current} max={creature.hit_points} iconSize={{width: iconSize.width*1.5, height: iconSize.height*2}} color={creature.border} />
                                    </div>
                                </div>
                                
                            )}
                        </div>
                    </>
                )}

                <div className='image-container'>
                    <img className="image" src={creature.avatarUrl} alt={name} style={{ outline: isTurn ? '2px solid rgba(255, 255, 255, 1)' : ''}}/>
                    
                    {isDead ? (
                        <>
                            <img className="image overlay-skull" src={skullpng} alt="" />
                            {showDeathSaves && (
                                <div style={{width: "65%"}}>
                                    <DeathSaves pass={creature.death_saves_success_count} fail={creature.death_saves_failure_count} />
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            {isBloodied && 
                                <img className="image" style={{opacity: tableView ? '1': '.8'}} src={getBloodImg(creature)} alt="" />
                            }
                        </>
                    )}                

                    {!tableView &&
                        <>
                            {effectsFound && (
                                <div className='avatarEffectsBar'>    
                                    {creature.effects.map((effectName) => (
                                        <img className='effectPlayerView'
                                            key={effectName}
                                            src={effectImgMap[effectName] || conditionImgMap[effectName]}
                                            alt={effectName}
                                        />
                                    ))}
                                </div>
                            )}
                            
                            {creature.inspiration &&
                                <div className='inspoRightBar'>    
                                    <InspirationSvg />
                                </div>
                            }

                            <div className="hpContainer">
                                
                                {showHp && ( 
                                    <div className="hpDiv" 
                                        style={{
                                            borderTop: `3px solid ${tableViewHpColor}`,
                                            textShadow: `-2px -2px 0 ${tableViewHpColor}, 2px -2px 0 ${tableViewHpColor}, -2px 2px 0 ${tableViewHpColor}, 2px 2px 0 ${tableViewHpColor}`
                                        }}>
                                        <span>{creature.hit_points_current}</span>
                                        {creature.hit_points_temp > 0 && <span className='tempHp hpDivSmall'>+{creature.hit_points_temp}</span>}
                                        <span className='hpDivSmall'> / {creature.hit_points}</span>
                                    </div>
                                )}

                                {hpBar && (
                                    <HealthBar current={creature.hit_points_current} max={creature.hit_points} iconSize={iconSize} color={creature.border} />
                                )}
                            </div>
                        </>
                
                    }
                    
                </div>
                
                <div className={tableView ? 'iconNameTableViewContainer' : 'iconNameContainer'}>
                    {tableView && creature.inspiration &&
                        <InspirationSvg />
                    }
                    <div className={tableView ? "nameTableView" : "name"} style={tableView ? {height: '16%'} : {}}>{name}</div> 
                    <div className={tableView ? "lastNameTableView" : "lastName"}> {lastName}</div>
                </div>

                {showInitiativeBox && 
                    <div className={tableView ? "initTableViewContainer" : "initDivContainer"}>
                        <div className={tableView ? 'initTableView' : 'initDiv'}>{creature.initiative}</div>
                    </div>
                }

                <>
                    {isExhausted && !tableView && ( 
                        <Exhaustion exhaustionLvl={creature.exhaustionLvl}/>
                    )}
                </>
            </div>
        </div>
    );
};

export default Icon;